import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Billing = lazy(() => import('./Billing'));

const BillingRoute: FuseRouteItemType = {
    path: 'billing/:page?',
    element: <Billing />,
    settings: {
        layout: {
            config: {
                toolbar: {
                    title: 'Billing',
                    helpName: 'Billing',
                    showCrumbs: false
                }
            }
        }
    }
};

export default BillingRoute;
